// Scorecard Widget Configuration
// A single 5-point dropdown scoring widget (-- to ++)

export type ScoreValue = '--' | '-' | '=' | '+' | '++';

export const SCORE_OPTIONS: { value: ScoreValue; label: string }[] = [
  { value: '--', label: '--' },
  { value: '-', label: '-' },
  { value: '=', label: '=' },
  { value: '+', label: '+' },
  { value: '++', label: '++' },
];

export const SCORE_COLORS: Record<ScoreValue, { bg: string; text: string; border: string }> = {
  '--': { bg: 'bg-danger-400', text: 'text-white', border: 'border-danger-400' },
  '-':  { bg: 'bg-danger-600', text: 'text-white', border: 'border-danger-600' },
  '=':  { bg: 'bg-neutral-400', text: 'text-white', border: 'border-neutral-400' },
  '+':  { bg: 'bg-success-600', text: 'text-white', border: 'border-success-600' },
  '++': { bg: 'bg-success-400', text: 'text-white', border: 'border-success-400' },
};

// Available layout variants for the scorecard widget. Same data, different
// presentation. Selected per-instance from the dashboard builder.
export type ScorecardLayout = 'carousel' | 'segmented';

export const SCORECARD_LAYOUTS: { value: ScorecardLayout; label: string }[] = [
  { value: 'carousel', label: 'Carousel' },
  { value: 'segmented', label: 'Segmented' },
];

export interface ScorecardWidgetConfig {
  showLabels?: boolean;
  layout?: ScorecardLayout;
}

export interface ScorecardWidgetInstanceConfig extends ScorecardWidgetConfig {
  dataKey: string;
}

// Dashboard data for a scorecard widget — just a single score
export interface ScorecardDataContent {
  score?: ScoreValue;
}
